<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="编码">
              <a-input placeholder="请输入编码" v-model="queryParam.code"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="耗材">
              <a-input placeholder="请输入耗材" v-model="queryParam.material"></a-input>
            </a-form-item>
          </a-col>

            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <temp-configMaterial-modal ref="modalForm" @ok="modalFormOk"></temp-configMaterial-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import TempConfigMaterialModal from './modules/TempConfigMaterialModal.vue'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "TempConfigMaterialList",
    mixins:[JeecgListMixin],
    components: {
      TempConfigMaterialModal
    },
    data () {
      return {
        description: '耗材成本列表管理页面',
        // 表头
        columns: [
		   {
            title: '项目名称',
            align:"center",
            dataIndex: 'name'
           },
          {
            title: '编码',
            align:"center",
            dataIndex: 'code'
          },
          {
            title: '耗材',
            align:"center",
            dataIndex: 'material'
          },
		   {
            title: '推荐',
            align:"center",
            dataIndex: 'recommendation'
           },
		   {
            title: '单价',
            align:"center",
            dataIndex: 'price'
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/tempconfig/configMaterial/list",
          delete: "/tempconfig/configMaterial/delete",
       },
    }
  },
  computed: {
  },
    methods: {
     
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>